import client from './client';
import { ExportConfig } from '../types';

export const exportConfigsApi = {
  list: (eventId: string) =>
    client.get<ExportConfig[]>(`/events/${eventId}/export-configs`).then((r) => r.data),

  create: (eventId: string, data: Omit<ExportConfig, '_id' | 'eventId' | 'createdAt'>) =>
    client.post<ExportConfig>(`/events/${eventId}/export-configs`, data).then((r) => r.data),

  delete: (eventId: string, id: string) =>
    client.delete(`/events/${eventId}/export-configs/${id}`).then((r) => r.data),
};
